import Header from '../../blocks/header/scripts.js'
import HeroSlider from '../../blocks/hero-slider/scripts.js'
import Button from '../../blocks/button/scripts.js'
// import DoubleImage from '../../blocks/double-image/scripts.js'
import Title from '../../blocks/title/scripts.js'
import TripleImage from '../../blocks/triple-image/scripts.js'
import DoubleSlider from '../../blocks/double-slider/scripts.js'
import Faq from '../../blocks/faq/scripts.js'
import ImageTexte from '../../blocks/image-texte/scripts.js'
import TitleText from '../../blocks/titletext/scripts.js'
import ButtonList from '../../blocks/buttonlist/scripts.js'

import MasonryGrid from '../../blocks/masonry-grid/scripts.js'
import TitleCta from '../../blocks/title-cta/scripts.js'
import Contact from '../../blocks/contact/scripts.js'
import ArticleBlog from '../../blocks/article-blog/scripts.js'
import initReveal from './reveal.js'
import initWordReveal from './word-reveal.js'
import initParallax from './parallax.js'
import Lenis from 'lenis' 

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.header').forEach(el => new Header(el))
  document.querySelectorAll('.hero-slider').forEach(el => new HeroSlider(el))
  document.querySelectorAll('.btn').forEach(el => new Button(el))
  // document.querySelectorAll('.double-image').forEach(el => new DoubleImage(el))
  document.querySelectorAll('.title').forEach(el => new Title(el))
  document.querySelectorAll('.triple-image').forEach(el => new TripleImage(el))
  document.querySelectorAll('.double-slider').forEach(el => new DoubleSlider(el))
  document.querySelectorAll('.faq').forEach(el => new Faq(el))
  document.querySelectorAll('.image-texte').forEach(el => new ImageTexte(el))
  document.querySelectorAll('.titletext').forEach(el => new TitleText(el))
  document.querySelectorAll('.buttonlist').forEach(el => new ButtonList(el))
  document.querySelectorAll('[data-block="masonry-grid"]').forEach(el => new MasonryGrid(el))
  document.querySelectorAll('.title-cta').forEach(el => new TitleCta(el))
  document.querySelectorAll('.contact').forEach(el => new Contact(el))
  document.querySelectorAll('.article-blog').forEach(el => new ArticleBlog(el))

  initReveal()
  initWordReveal()
  initParallax()

  new Lenis({
    autoRaf: true,
    lerp: 0.06,
    wheelMultiplier: 0.7
  })

});
